import $ from 'jquery'
import axios from 'axios'
import Parse from '../services/Parse'
import Collection from '../../../utils/Collection'

const defaultSelectors = {
  fileInput: '#orders-file',
  codesInput: '#add-products-to-order',
  uploadButton: '#btn-upload',
  submitButton: '#btn-submit',
}

class UploadController {
  constructor ({
    parseService,
    httpClient,
    collection,
    selectors,
    notify,
    redirect,
    $root,
  }) {
    this.parseService = parseService
    this.httpClient = httpClient
    this.collection = collection
    this.selectors = selectors
    this.notify = message => alert(message)
    this.redirect = redirect
    this.$ = $root
  }

  getOrderFileInput = () => this.$(this.selectors.fileInput)

  getOrderCodesInput = () => this.$(this.selectors.codesInput)

  markFileUploaded = () => {
    this.$(this.selectors.uploadButton)
      .html('Загружен 1 файл')
      .addClass('btn btn-light icon icon_pre icon_pre-pencil mt-1 ps-4')
  }

  openDialog = () => {
    this.getOrderFileInput().click()
  }

  handleSelectedFile = async event => {
    const { target } = event
    this.markFileUploaded()

    const rows = await this.parseService.parseFile(target.files[0])
    ;(rows || []).forEach(row => this.collection.add(row))
  }

  handleChangeText = ({ target }) => {
    this.parseService.parseText(target.value)
      .forEach(row => this.collection.add(row))
  }

  handleAddToCart = ({ target }) => {
    const url = target.getAttribute('data-url')

    if (!this.collection.getAll().length) {
      this.notify('Артикулы не найдены')
      return
    }

    this.$(target).prop('disabled', true)
    this.getOrderCodesInput().prop('disabled', true)

    return this.httpClient.post(url, this.collection.getAll()).then(({ data }) => {
      if (data.redirect) {
        this.redirect(data.redirect)
        return
      }
      data.message && this.notify(data.message)
    })
    .catch(error => {
      const message = error.response?.data?.message || 'Не удалось добавить товары'
      this.notify(message)
    })
    .finally(() => {
      this.$(target).prop('disabled', false)
      this.getOrderCodesInput().prop('disabled', false)
    })
  }

  init = () => {
    this.$(() => {
      this.$(this.selectors.uploadButton).click(this.openDialog)
      this.getOrderFileInput().change(this.handleSelectedFile)
      this.getOrderCodesInput().change(this.handleChangeText)
      this.$(this.selectors.submitButton).click(this.handleAddToCart)
    })
  }
}

const createUploadController = ({
  parseService = Parse,
  httpClient = axios,
  collection = Collection.create(),
  selectors = defaultSelectors,
  notify = message => alert(message),
  redirect = url => { window.location = url },
  $root = $,
} = {}) => new UploadController({
  parseService,
  httpClient,
  collection,
  selectors,
  notify,
  redirect,
  $root,
})

export { UploadController, createUploadController }
export default createUploadController().init()
